export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      gallery: "Galerie",
      contact: "Contact",
      track: "Suivi",
      login: "Connexion",
      news: "Actualités",
      history: "Histoire",
      cta: "Devis Instantané",
    },
    news: {
      overline: "Actualités",
      title: "Toute l'actualité de",
      accent: "l'atelier",
      sub: "Promotions, nouveaux services et vie de l'atelier : suivez les dernières informations de Groupe Auto Luxe.",
      all: "Toute l'actualité",
      read: "Lire la suite",
      back: "Retour aux actualités",
      empty: "Aucune actualité pour le moment. Revenez bientôt !",
      filterAll: "Toutes",
      link: "En savoir plus",
      tabs: { ours: "Notre atelier", ci: "Côte d'Ivoire", world: "Monde", auto: "Automobile" },
      external: { overline: "À la une", title: "Côte d'Ivoire, monde &", accent: "automobile", ci: "En Côte d'Ivoire", world: "Dans le monde", auto: "Côté automobile", readOn: "Lire l'article", empty: "Flux indisponible pour le moment.", updated: "Mis à jour automatiquement toutes les 30 minutes à partir de sources externes", more: "Voir plus" },
      categories: { promo: "Promotion", service: "Nouveau service", atelier: "Vie de l'atelier", info: "Information" },
      share: { label: "Partager", whatsapp: "WhatsApp", facebook: "Facebook", copy: "Copier le lien", copied: "Lien copié !" },
    },
    history: {
      overline: "Notre histoire",
      title: "Une histoire qui",
      accent: "avance",
      intro: "Groupe Auto Luxe est né à Koumassi-Remblais d'une passion pour la mécanique et d'une conviction simple : la satisfaction du client passe avant tout. Année après année, l'atelier de quartier est devenu un réparateur multimarques agréé par les compagnies d'assurance, puis, en 2024, une société formellement constituée disposant de deux garages modernes à Abidjan.",
      missionTitle: "Au-delà de la réparation",
      mission: "Notre ambition dépasse la réparation automobile. Nous voulons contribuer au développement de la Côte d'Ivoire en formant et en employant des jeunes dans les métiers de l'automobile, en transmettant un savoir-faire exigeant et en offrant des perspectives durables à la nouvelle génération. Chaque véhicule réparé est aussi une compétence transmise.",
      milestones: [
        { year: "Origines", title: "Les débuts à Koumassi", text: "Ouverture de l'atelier à Koumassi-Remblais : mécanique générale, tôlerie et peinture pour une clientèle de quartier fidèle." },
        { year: "2023", title: "Agréments assurances", text: "Premiers agréments auprès des compagnies d'assurance et des cabinets d'expertise pour la réparation de véhicules sinistrés et l'assistance technique. Les dossiers confiés sont menés dans les délais et avec la qualité attendue." },
        { year: "2024", title: "Formalisation en SARL", text: "Constitution de la société Groupe Auto Luxe SARL, dotée d'un capital social de 1 000 000 FCFA et d'une durée de 99 ans, immatriculée au Registre du Commerce d'Abidjan et déclarée auprès des administrations fiscale et sociale." },
        { year: "2024", title: "Deux garages modernes", text: "Ouverture d'un second site à Port-Bouët Gonzagueville, aux côtés de l'atelier de Koumassi-Remblais. Nos techniciens, formés aux nouvelles technologies, interviennent sur toutes les marques dans le respect des cahiers des charges des constructeurs." },
        { year: "Depuis 2025", title: "Cap sur l'avenir", text: "Élargissement des activités à la vente de pièces, à la location et à l'import-export, avec un engagement concret pour la formation et l'emploi des jeunes ivoiriens." },
      ],
      facts: [
        { label: "Forme juridique", value: "SARL" },
        { label: "Capital social", value: "1 000 000 FCFA" },
        { label: "Durée", value: "99 ans" },
        { label: "Sites", value: "2 garages à Abidjan" },
        { label: "Agréé assurances", value: "depuis 2023" },
        { label: "Marques servies", value: "20+" },
      ],
      charterTitle: "Notre charte qualité",
      charter: ["Accueil · Disponibilité · Réactivité", "Clarté · Rigueur · Transparence", "Personnalisation · Écoute · Suivi", "Compétences · Expérience · Savoir-faire", "Confidentialité · Respect · Discrétion", "Qualité · Évaluation · Amélioration"],
    },
    estimate: {
      overline: "Votre devis",
      title: "Devis N°",
      sub: "Vérifiez le détail ci-dessous puis acceptez ou refusez en un clic.",
      pdf: "Voir le PDF",
      accept: "J'accepte le devis",
      refuse: "Je refuse",
      comment: "Un commentaire pour l'atelier (optionnel)",
      accepted: "Merci ! Votre devis est accepté. L'atelier vous contacte rapidement pour organiser l'intervention.",
      refused: "Votre refus a bien été transmis à l'atelier. N'hésitez pas à nous appeler pour en discuter.",
      alreadyOn: "Décision enregistrée le",
      notFound: "Ce devis est introuvable ou le lien a expiré.",
      total: "Total",
      validity: "Valable",
      days: "jours",
      hello: "Bonjour",
    },
    track: {
      overline: "Suivi de réparation",
      title: "Où en est",
      titleAccent: "mon véhicule ?",
      sub: "Saisissez le code de suivi reçu lors de votre demande (ex : GAL-3F9A2C) pour connaître l'avancement de votre véhicule.",
      placeholder: "GAL-XXXXXX",
      button: "Suivre",
      notFound: "Code introuvable. Vérifiez le code reçu lors de votre demande.",
      pending: "Votre demande est bien enregistrée. Le suivi démarrera dès la réception de votre véhicule à l'atelier.",
      steps: { recu: "Véhicule reçu", en_cours: "Réparation en cours", pret: "Véhicule prêt", livre: "Véhicule livré" },
      stepsDesc: {
        recu: "Votre véhicule est à l'atelier, le diagnostic est en cours.",
        en_cours: "Nos techniciens travaillent sur votre véhicule.",
        pret: "Votre véhicule vous attend ! Contactez-nous pour le récupérer.",
        livre: "Merci pour votre confiance. À bientôt chez Groupe Auto Luxe.",
      },
      hello: "Bonjour",
      vehicle: "Véhicule",
      service: "Service",
      rdv: "Rendez-vous",
      history: "Historique",
      codeLabel: "Votre code de suivi",
      codeHint: "Conservez-le : il vous permettra de suivre l'avancement de votre véhicule sur la page Suivi.",
    },
    hero: {
      badge: "Atelier de réparation automobile agréé par les compagnies d'assurances à Abidjan",
      line1: "L'excellence",
      line2: "automobile",
      line3: "à Abidjan",
      sub: "Mécanique, tôlerie, peinture, électricité, tapisserie et climatisation : votre véhicule entre les mains de maîtres artisans.",
      ctaQuote: "Demander un devis",
      ctaWhats: "WhatsApp direct",
      chips: ["Diagnostic 100%", "Peinture Haute Définition", "Pièces Certifiées"],
      scroll: "Défiler",
    },
    marquee: ["GROUPE AUTO LUXE", "MÉCANIQUE", "TÔLERIE", "PEINTURE", "ÉLECTRICITÉ", "TAPISSERIE", "CLIMATISATION", "ABIDJAN 01"],
    credo: {
      overline: "Notre Credo",
      text: "La satisfaction client, notre credo. Chaque véhicule qui entre dans notre atelier reçoit le même niveau d'exigence : celui d'une œuvre d'art.",
    },
    stats: {
      items: [
        { v: "6", l: "Disciplines expertes" },
        { v: "20+", l: "Marques servies" },
        { v: "10+", l: "Assurances partenaires" },
        { v: "24h", l: "Délai de réponse" },
      ],
    },
    servicesPreview: {
      overline: "Nos Savoir-Faire",
      title: "Six disciplines, une obsession",
      cta: "Découvrir tous nos services",
    },
    activities: {
      overline: "Nos Activités",
      title: "Bien plus qu'un",
      titleAccent: "atelier",
      sub: "Groupe Auto Luxe intervient sur toute la chaîne de valeur automobile : de la réparation à la vente, de la location à l'import-export.",
      items: [
        { title: "Mécanique générale", desc: "Entretien, réparation et diagnostic toutes marques par des techniciens qualifiés." },
        { title: "Vente de pièces auto", desc: "Pièces détachées d'origine et compatibles, disponibles ou sur commande rapide." },
        { title: "Achat, vente et location de véhicules", desc: "Véhicules d'occasion vérifiés, accompagnement à l'achat et location courte ou longue durée." },
        { title: "Prestations diverses", desc: "Assistance technique, expertise, convoyage et services sur mesure pour particuliers et entreprises." },
        { title: "Commerce général", desc: "Négoce et distribution de produits et équipements liés au secteur automobile." },
        { title: "Import – Export", desc: "Importation de véhicules et pièces, exportation et logistique internationale." },
      ],
    },
    services: {
      overline: "Nos Savoir-Faire",
      title: "Six disciplines,",
      titleAccent: "une obsession",
      sub: "De la mécanique de précision à la tapisserie d'exception, chaque discipline est un chapitre de notre manifeste artisanal.",
      specsLabel: "Prestations clés",
      quoteCta: "Demander un devis",
      items: [
        {
          num: "01",
          title: "Mécanique",
          tagline: "Le cœur de la machine",
          desc: "Diagnostic électronique complet, révision moteur, freinage, suspension et transmission. Nos techniciens redonnent à votre véhicule sa performance d'origine, ou mieux.",
          specs: ["Diagnostic électronique multi-marques", "Révision et réfection moteur", "Freinage, suspension, transmission", "Entretien préventif programmé"],
        },
        {
          num: "02",
          title: "Tôlerie",
          tagline: "L'art du redressage",
          desc: "Débosselage, redressage sur banc, remplacement d'éléments de carrosserie. Nous restaurons la géométrie exacte de votre véhicule après tout choc.",
          specs: ["Redressage sur banc de précision", "Débosselage sans peinture", "Remplacement d'éléments d'origine", "Réparation structurelle après accident"],
        },
        {
          num: "03",
          title: "Peinture",
          tagline: "La haute définition",
          desc: "Cabine de peinture professionnelle, teinte d'origine garantie, finition haute définition. Votre carrosserie retrouve son éclat de showroom.",
          specs: ["Cabine de peinture professionnelle", "Teinte d'origine par spectrophotomètre", "Finition haute définition", "Traitement céramique sur demande"],
        },
        {
          num: "04",
          title: "Électricité",
          tagline: "Le système nerveux",
          desc: "Faisceaux, alternateurs, démarreurs, électronique embarquée et systèmes multimédia. Nous maîtrisons les réseaux électriques les plus complexes.",
          specs: ["Diagnostic des faisceaux électriques", "Alternateurs et démarreurs", "Électronique embarquée et calculateurs", "Systèmes audio et multimédia"],
        },
        {
          num: "05",
          title: "Tapisserie",
          tagline: "L'intérieur d'exception",
          desc: "Sellerie cuir, réfection de sièges, ciels de toit et habillages sur mesure. Nous transformons votre habitacle en écrin de luxe.",
          specs: ["Sellerie cuir et alcantara", "Réfection complète de sièges", "Ciels de toit et panneaux de porte", "Habillage sur mesure"],
        },
        {
          num: "06",
          title: "Climatisation",
          tagline: "Le confort absolu",
          desc: "Recharge de gaz, remplacement de compresseur, détection de fuites et désinfection du circuit. Un air pur et frais, toute l'année.",
          specs: ["Recharge et diagnostic du circuit", "Remplacement de compresseur", "Détection de fuites aux UV", "Désinfection et traitement anti-bactérien"],
        },
      ],
    },
    gallery: {
      overline: "Notre Atelier",
      title: "Le travail parle",
      titleAccent: "de lui-même",
      sub: "Les vraies photos de notre atelier, de nos équipes et de nos réalisations. Rien d'inventé, simplement la réalité de Groupe Auto Luxe.",
      filters: { all: "Tous", entreprise: "L'Entreprise", mecanique: "Mécanique & Diagnostic", tolerie: "Tôlerie & Peinture", tapisserie: "Tapisserie & Intérieur", formation: "Formation & Jeunes" },
      empty: "Aucune photo dans cette catégorie pour le moment. Les responsables publient les photos depuis l'espace entreprise.",
      count: "photos",
      items: [
        { cat: "mecanique", caption: "Réfection moteur V8" },
        { cat: "mecanique", caption: "Diagnostic baie moteur" },
        { cat: "mecanique", caption: "Intervention sur pont" },
        { cat: "tolerie", caption: "Finition peinture studio" },
        { cat: "tolerie", caption: "SUV en restauration" },
        { cat: "tolerie", caption: "Atelier carrosserie premium" },
        { cat: "tapisserie", caption: "Habitacle cuir sur mesure" },
        { cat: "tapisserie", caption: "Sellerie nuit étoilée" },
      ],
    },
    leadership: {
      overline: "La Direction",
      title: "Des mains expertes,",
      titleAccent: "une vision claire",
      members: [
        {
          name: "Kola Cissé Barry",
          role: "Président du Conseil d'Administration (PCA)",
          phone: "+225 07 88 16 24 02",
          bio: "À la tête du Conseil d'Administration, il porte la vision de Groupe Auto Luxe : une entreprise ivoirienne exemplaire, tournée vers l'excellence, la formation des jeunes et le développement du pays.",
        },
        {
          name: "Ousmane B. Traore",
          role: "Directeur Général",
          phone: "+225 05 05 54 13 13",
          bio: "Visionnaire et bâtisseur, il a fait de Groupe Auto Luxe la référence de l'automobile premium à Abidjan, avec une exigence absolue : la satisfaction de chaque client.",
        },
        {
          name: "Abdoul-Alim Diallo",
          role: "Conseiller du Directeur Général, responsable du pôle Intelligence économique",
          phone: "+33 7 80 79 68 27",
          bio: "Il accompagne la direction dans ses décisions stratégiques : veille sur le marché automobile, analyse de la concurrence et des opportunités, partenariats et développement de l'entreprise.",
        },
        {
          name: "Zakaria Diallo",
          role: "Responsable Technique",
          phone: "+225 07 48 83 38 40",
          bio: "Maître technicien et garant de la qualité, il supervise chaque intervention avec la rigueur d'un ingénieur et la passion d'un artisan.",
        },
      ],
    },
    partners: {
      overline: "Agréments & Partenaires",
      title: "Agréé par les plus",
      titleAccent: "grandes assurances",
      sub: "Groupe Auto Luxe est un atelier agréé pour la réparation et l'assistance technique de véhicules assurés. Votre sinistre est pris en charge directement, sans avance de frais selon votre contrat.",
      groupAssurance: "Compagnies d'assurance",
      groupExpertise: "Cabinets d'expertise & organismes",
      legal: "RCCM : CI-ABJ-03-2024-B12-08712 · IDU : CI-2024-0019709 J",
      brandsLabel: "Toutes marques servies",
      brands: ["TOYOTA", "MERCEDES-BENZ", "BMW", "VOLKSWAGEN", "AUDI", "PEUGEOT", "RENAULT", "NISSAN", "HYUNDAI", "KIA", "HONDA", "FORD", "VOLVO", "SUZUKI", "MAZDA", "MITSUBISHI", "CITROËN", "OPEL", "FIAT", "DACIA"],
    },
    testimonials: {
      overline: "Avis Clients",
      title: "Ils nous ont confié",
      titleAccent: "leur véhicule",
      sub: "Des avis authentiques, publiés après validation par notre équipe.",
      empty: "Soyez le premier à partager votre expérience avec Groupe Auto Luxe.",
      leave: "Laisser un avis",
      form: {
        name: "Votre nom",
        vehicle: "Votre véhicule (optionnel)",
        rating: "Votre note",
        comment: "Votre avis",
        commentPh: "Racontez votre expérience...",
        submit: "Envoyer mon avis",
        success: "Merci ! Votre avis sera publié après validation.",
        error: "Impossible d'envoyer l'avis. Réessayez.",
      },
    },
    beforeAfter: {
      overline: "Avant / Après",
      title: "Glissez pour voir",
      titleAccent: "la transformation",
      sub: "Faites glisser le curseur pour comparer l'état du véhicule avant et après notre intervention.",
      before: "Avant",
      after: "Après",
      empty: "Nos premières comparaisons avant / après arrivent bientôt.",
      cta: "Voir toutes les transformations",
    },
    faq: {
      overline: "Questions Fréquentes",
      title: "Tout savoir avant de",
      titleAccent: "nous confier votre véhicule",
      items: [
        {
          q: "Êtes-vous agréés par les compagnies d'assurance ?",
          a: "Oui. Groupe Auto Luxe est agréé pour la réparation de véhicules et l'assistance technique auprès des principales assurances du pays (GNA-CI, NSIA, Sanlam Allianz, SUNU, Activa, AFG...). Nous gérons directement votre dossier de sinistre avec votre assureur.",
        },
        {
          q: "Quelles marques de véhicules acceptez-vous ?",
          a: "Toutes les marques : Toyota, Mercedes-Benz, BMW, Peugeot, Renault, Hyundai, Kia, Nissan, Volkswagen, Audi et bien d'autres. Notre équipement de diagnostic est multi-marques.",
        },
        {
          q: "En combien de temps obtient-on un devis ?",
          a: "Nous répondons à toute demande sous 24h ouvrées. Pour une estimation encore plus rapide, envoyez-nous des photos des dégâts directement sur WhatsApp au +225 05 05 54 13 13.",
        },
        {
          q: "Où se trouve l'atelier exactement ?",
          a: "Nous disposons de deux sites à Abidjan : Koumassi Remblais, juste derrière la station PETROCI (01 BP 924 Abidjan 01), et Port-Bouët Gonzagueville. Ouvert du lundi au samedi, de 8h00 à 18h00.",
        },
        {
          q: "Intervenez-vous avant les travaux pour l'expertise ?",
          a: "Oui. Nous réalisons un diagnostic complet avec rapport photo avant, pendant et après travaux : un dossier transparent accepté par les experts d'assurance.",
        },
      ],
    },
    recruit: {
      nav: "Nous rejoindre",
      overline: "Nous rejoindre",
      title: "Construisons l'avenir",
      accent: "ensemble",
      sub: "Groupe Auto Luxe forme et recrute des jeunes passionnés d'automobile. Emploi, stage ou formation : votre parcours commence ici, à Abidjan.",
      pillars: {
        job: { title: "Emploi", desc: "Rejoignez une équipe de techniciens qualifiés, dans un atelier agréé par les compagnies d'assurances." },
        internship: { title: "Stage", desc: "Étudiants et jeunes diplômés : découvrez le métier sur le terrain, encadrés par des professionnels expérimentés." },
        training: { title: "Formation", desc: "Apprenez la mécanique, la tôlerie, la peinture ou l'électricité automobile aux côtés de nos experts." },
      },
      offersTitle: "Nos offres en cours",
      noOffers: "Aucune offre publiée pour le moment. Envoyez-nous une candidature spontanée, nous étudions chaque profil.",
      apply: "Postuler",
      formTitle: "Déposer ma candidature",
      formSub: "Quelques informations suffisent. Nous vous recontactons rapidement par téléphone ou WhatsApp.",
      form: {
        type: "Je souhaite",
        offer: "Offre concernée",
        spontaneous: "Candidature spontanée",
        domain: "Domaine souhaité",
        domainPh: "Choisissez un domaine",
        domains: ["Mécanique", "Tôlerie", "Peinture", "Électricité automobile", "Climatisation", "Tapisserie", "Accueil et administration", "Autre"],
        message: "Présentez-vous en quelques lignes",
        messagePh: "Votre parcours, vos motivations, vos disponibilités...",
        cv: "Votre CV (PDF, Word ou image, 5 Mo max)",
        cvChoose: "Joindre mon CV",
        cvOptional: "Facultatif mais recommandé",
        submit: "Envoyer ma candidature",
        sending: "Envoi en cours...",
        success: "Candidature envoyée ! Merci pour votre confiance, nous vous recontactons très vite.",
        again: "Envoyer une autre candidature",
        error: "Une erreur est survenue. Réessayez ou contactez-nous sur WhatsApp.",
      },
      types: { job: "Un emploi", internship: "Un stage", training: "Une formation" },
      galleryOverline: "En images",
      galleryTitle: "La vie de l'atelier,",
      galleryAccent: "côté jeunes",
      gallerySub: "Apprentis et stagiaires au travail, encadrés par nos techniciens.",
      galleryAll: "Voir toute la galerie",
      testimonialsOverline: "Ils ont commencé ici",
      testimonialsTitle: "Des jeunes qui",
      testimonialsAccent: "témoignent",
      testimonials: [
        { name: "Yao Kouassi", role: "Apprenti mécanicien, 21 ans", text: "Je suis arrivé sans expérience. En six mois, j'ai appris le diagnostic, la vidange, les freins. Les techniciens prennent le temps d'expliquer, on n'est jamais laissé seul." },
        { name: "Aïcha Diabaté", role: "Stagiaire tôlerie et peinture", text: "Mon stage m'a permis de toucher à la vraie tôlerie, sur des véhicules de clients et d'assurances. Aujourd'hui je sais préparer une carrosserie du redressage jusqu'au vernis." },
        { name: "Moussa Traoré", role: "Électricien automobile, embauché après sa formation", text: "Formé ici, embauché ici. Groupe Auto Luxe m'a fait confiance et m'a donné un métier. C'est cette chance que je veux transmettre aux plus jeunes." },
      ],
    },
    vehicles: {
      nav: "Véhicules",
      overline: "Vente, achat & location",
      title: "Trouvez votre",
      accent: "prochain véhicule",
      sub: "Véhicules d'occasion contrôlés par notre atelier, à vendre ou à louer à Abidjan. Vous souhaitez vendre le vôtre ? Nous l'achetons.",
      tabs: { all: "Tous", sale: "À vendre", rent: "À louer", part_sale: "Pièces à vendre", part_wanted: "Pièces recherchées" },
      kind: { sale: "À vendre", rent: "À louer", part_sale: "Pièce à vendre", part_wanted: "Pièce recherchée" },
      heads: {
        rent: { overline: "Location de véhicules", title: "Louez un véhicule", accent: "fiable et entretenu", sub: "Berlines, SUV et utilitaires révisés par notre atelier, à la journée, à la semaine ou au mois. Chauffeur possible sur demande." },
        part_sale: { overline: "Pièces détachées", title: "Pièces d'origine", accent: "et d'occasion contrôlées", sub: "Pièces mécaniques, carrosserie, électricité et accessoires vérifiés par nos techniciens, avec pose possible à l'atelier." },
        part_wanted: { overline: "Nous achetons vos pièces", title: "Vous avez", accent: "la pièce qu'il nous faut ?", sub: "Nous recherchons ces pièces pour nos réparations en cours. Si vous en possédez une, cliquez « J'ai cette pièce » : nous vous rappelons pour convenir du prix." },
      },
      request: {
        rent: { overline: "Demande de location", title: "Réservez", accent: "votre véhicule", sub: "Indiquez le type de véhicule, les dates et la durée : nous vous confirmons la disponibilité et le tarif rapidement.", subject: "Demande de location de véhicule", needLabel: "Véhicule souhaité et dates", needPh: "Ex : SUV 7 places du 12 au 15 mars, avec chauffeur", extraLabel: "Budget ou précisions", extraPh: "Ex : 50 000 FCFA / jour maximum", submit: "Envoyer ma demande de location", success: "Demande reçue ! Nous vous confirmons la disponibilité très vite.", again: "Nouvelle demande", waIntro: "Bonjour, je souhaite louer un véhicule :" },
        part_sale: { overline: "Vous cherchez une pièce ?", title: "Demandez", accent: "la pièce qu'il vous faut", sub: "Vous ne trouvez pas votre pièce dans la liste ? Décrivez-la : nous la cherchons dans notre stock ou chez nos fournisseurs.", subject: "Recherche de pièce détachée", needLabel: "Pièce recherchée et véhicule", needPh: "Ex : Alternateur pour Toyota Hilux 2018 diesel", extraLabel: "Référence, état souhaité, budget", extraPh: "Ex : neuf ou occasion, 150 000 FCFA max", submit: "Demander cette pièce", success: "Demande reçue ! Nous vous répondons rapidement avec un prix et un délai.", again: "Demander une autre pièce", waIntro: "Bonjour, je recherche une pièce :" },
        part_wanted: { overline: "Vous avez une pièce à nous proposer ?", title: "Proposez", accent: "votre pièce", sub: "Même si elle n'est pas dans notre liste, décrivez la pièce que vous souhaitez vendre : nous vous faisons une offre après vérification.", subject: "Proposition de pièce détachée", needLabel: "Pièce proposée et véhicule compatible", needPh: "Ex : Phare avant droit Prado 2017, occasion bon état", extraLabel: "Prix souhaité", extraPh: "Ex : 80 000 FCFA", submit: "Proposer ma pièce", success: "Merci ! Nous vous rappelons pour convenir du prix.", again: "Proposer une autre pièce", waIntro: "Bonjour, je vous propose une pièce :" },
      },
      parts: {
        category: { moteur: "Moteur", carrosserie: "Carrosserie", freinage: "Freinage", electrique: "Électrique", pneus: "Pneus & jantes", accessoires: "Accessoires", autre: "Autre" },
        condition: { neuf: "Neuf", occasion: "Occasion", reconditionne: "Reconditionné" },
        compatible: "Véhicules compatibles", quantity: "Quantité", categoryLabel: "Catégorie", conditionLabel: "État",
        wanted: "Nous recherchons cette pièce", wantedSub: "Vous possédez cette pièce ou pouvez la fournir ? Laissez vos coordonnées, nous vous rappelons pour convenir du prix.",
        haveIt: "J'ai cette pièce", haveItSent: "Merci ! Nous vous rappelons très vite pour cette pièce.",
        empty: "Aucune pièce dans cette catégorie pour le moment. Contactez-nous : nous pouvons la commander pour vous.",
        emptyWanted: "Aucune pièce recherchée pour le moment. Vous avez une pièce à nous proposer ? Utilisez le formulaire ci-dessous.",
        homeOverline: "Pièces détachées", homeTitle: "Pièces", homeAccent: "à vendre", homeAccentWanted: "à vendre et recherchées",
        homeSub: "Pièces d'origine et d'occasion contrôlées par notre atelier. Vous avez une pièce que nous recherchons ? Dites-le nous.",
        all: "Voir toutes les pièces",
        search: "Rechercher une pièce", searchPh: "Rechercher : nom, véhicule compatible, référence…", allCategories: "Toutes", noResult: "Aucune pièce ne correspond à votre recherche. Essayez un autre mot ou une autre catégorie.",
      },
      status: { available: "Disponible", reserved: "Réservé" },
      onRequest: "Prix sur demande",
      perDay: "/ jour",
      photos: "photos",
      color: "Couleur",
      fuel: { essence: "Essence", diesel: "Diesel", hybride: "Hybride", electrique: "Électrique", autre: "Autre" },
      gearbox: { manuelle: "Manuelle", automatique: "Automatique" },
      details: "Voir",
      interestTitle: "Ce véhicule vous intéresse ?",
      interestSub: "Laissez vos coordonnées, un conseiller vous rappelle rapidement. Ou écrivez-nous directement sur WhatsApp.",
      message: "Votre message (facultatif)",
      messagePh: "Ex : Je souhaite l'essayer samedi matin.",
      send: "Envoyer ma demande",
      sending: "Envoi...",
      whatsapp: "Discuter sur WhatsApp",
      sent: "Demande envoyée ! Nous vous rappelons très vite.",
      empty: "Aucun véhicule disponible pour le moment. Contactez-nous : nous pouvons rechercher le véhicule qu'il vous faut.",
      homeTitle: "Véhicules",
      homeAccent: "à vendre et à louer",
      all: "Voir tous les véhicules",
      openPage: "Voir la fiche complète",
      back: "Tous les véhicules",
      notFound: "Ce véhicule n'est plus disponible.",
      sell: {
        overline: "Nous achetons",
        title: "Vendez-nous",
        accent: "votre véhicule",
        sub: "Décrivez votre véhicule, ajoutez quelques photos et indiquez le prix souhaité. Nous vous faisons une offre après expertise à l'atelier.",
        brand: "Marque", model: "Modèle", year: "Année", mileage: "Kilométrage (km)", fuel: "Carburant", gearbox: "Boîte de vitesses",
        price: "Prix souhaité (FCFA, facultatif)", photos: "Photos du véhicule", message: "Description, état, options",
        messagePh: "Ex : Première main, carnet d'entretien complet, pneus neufs.",
        submit: "Proposer mon véhicule",
        success: "Merci ! Votre proposition a bien été reçue, nous vous contactons rapidement.",
        again: "Proposer un autre véhicule",
        error: "Envoi impossible, réessayez.",
      },
    },
    seo: {
      home: { title: "Garage automobile agréé assurances à Abidjan : mécanique, tôlerie, peinture", description: "Groupe Auto Luxe, garage automobile à Abidjan (Koumassi, Port-Bouët) agréé par les compagnies d'assurances : mécanique, tôlerie, peinture, électricité, climatisation, tapisserie. Devis gratuit, suivi de réparation en ligne." },
      services: { title: "Nos services : mécanique, tôlerie, peinture, électricité auto à Abidjan", description: "Découvrez tous les services de notre garage à Abidjan : mécanique générale, tôlerie et peinture, électricité automobile, climatisation, tapisserie, pièces détachées, location et import-export de véhicules." },
      gallery: { title: "Galerie : nos réalisations et notre atelier", description: "Photos de nos réparations, de nos ateliers de Koumassi et Port-Bouët et de nos équipes au travail. Avant / après tôlerie et peinture." },
      contact: { title: "Devis gratuit, rendez-vous ou enlèvement de véhicule à Abidjan", description: "Demandez un devis gratuit, prenez rendez-vous à l'atelier, faites chercher votre véhicule à domicile ou posez votre question. Réponse rapide par téléphone ou WhatsApp." },
      history: { title: "Notre histoire : un garage ivoirien engagé pour la jeunesse", description: "De l'atelier de quartier à la SARL agréée par les assurances : l'histoire de Groupe Auto Luxe, ses valeurs, sa charte qualité et son engagement pour la formation et l'emploi des jeunes en Côte d'Ivoire." },
      news: { title: "Actualités : atelier, Côte d'Ivoire, monde et automobile", description: "Promotions, nouveaux services et vie de l'atelier Groupe Auto Luxe, ainsi que l'actualité de la Côte d'Ivoire, du monde et de l'automobile." },
      recruit: { title: "Nous rejoindre : emploi, stage et formation en mécanique automobile à Abidjan", description: "Groupe Auto Luxe recrute et forme des jeunes passionnés d'automobile à Abidjan : offres d'emploi, stages et formations en mécanique, tôlerie, peinture et électricité auto." },
      vehicles: { title: "Véhicules d'occasion à vendre et à louer à Abidjan", description: "Voitures d'occasion contrôlées par l'atelier Groupe Auto Luxe, à vendre ou à louer à Abidjan. Nous achetons aussi votre véhicule : proposez-le en ligne avec photos." },
      track: { title: "Suivre la réparation de mon véhicule", description: "Suivez en temps réel l'avancement de la réparation de votre véhicule grâce à votre code de suivi." },
    },
    maps: { overline: "Nos garages", title: "Où nous", accent: "trouver", sub: "Deux sites à Abidjan pour vous accueillir du lundi au samedi.", directions: "Itinéraire", hours: "Horaires", open: "Ouvrir dans Google Maps" },
    track_docs: { invoice: "Télécharger ma facture (PDF)", estimate: "Télécharger mon devis (PDF)", paid: "Facture réglée, merci", scan: "Scanner pour payer avec" },
    vcard: {
      overline: "Cartes de visite",
      title: "Gardez-nous",
      accent: "dans vos contacts",
      sub: "Scannez le QR code avec votre téléphone ou téléchargez la fiche contact (vCard) pour enregistrer directement nos responsables dans votre répertoire.",
      scan: "Scannez pour ajouter le contact",
      download: "Télécharger la vCard",
    },
    contact: {
      overline: "Contact & Devis",
      title: "Parlons de",
      titleAccent: "votre véhicule",
      sub: "Décrivez votre besoin, nous vous répondons sous 24h avec un devis détaillé et sans engagement.",
      types: {
        devis: { title: "Demander un devis", desc: "Décrivez les travaux, ajoutez des photos : nous chiffrons sous 24h, sans engagement." },
        rdv: { title: "Rendez-vous à l'atelier", desc: "Vous venez avec votre véhicule à la date et à l'heure de votre choix." },
        pickup: { title: "Faire chercher mon véhicule", desc: "Nous venons récupérer votre véhicule à l'adresse indiquée." },
        question: { title: "Poser une question", desc: "Une simple question ? Écrivez-nous, nous répondons rapidement." },
      },
      form: {
        devisMessage: "Décrivez les travaux à chiffrer",
        devisMessagePh: "Ex : rayure sur la portière avant gauche, bruit au freinage, remplacement du pare-chocs...",
        devisSubmit: "Recevoir mon devis",
        devisSuccess: "Demande de devis envoyée ! Vous recevez notre chiffrage sous 24h.",
        devisWaIntro: "Bonjour Groupe Auto Luxe, je souhaite un devis :",
        rdvMessage: "Motif du rendez-vous",
        rdvMessagePh: "Ex : vidange + contrôle des freins, diagnostic voyant moteur...",
        rdvSubmit: "Réserver mon rendez-vous",
        rdvSuccess: "Rendez-vous demandé ! Nous vous confirmons le créneau sous 24h.",
        rdvWaIntro: "Bonjour Groupe Auto Luxe, je viens de demander un rendez-vous à l'atelier :",
        pickupMessage: "État du véhicule et travaux souhaités",
        pickupMessagePh: "Ex : ne démarre plus, roule mais fait un bruit, accident léger...",
        pickupSubmit: "Demander l'enlèvement",
        pickupWaIntro: "Bonjour Groupe Auto Luxe, je viens de demander l'enlèvement de mon véhicule :",
        pickupAddress: "Adresse d'enlèvement du véhicule",
        pickupAddressPh: "Quartier, rue, repère (ex : Cocody Riviera 3, près de la pharmacie ...)",
        pickupDate: "Date d'enlèvement souhaitée",
        period: "Période souhaitée",
        periodPh: "Choisissez une période",
        periodMorning: "Matin (8h à 12h)",
        periodAfternoon: "Après-midi (12h à 18h)",
        pickupNote: "Enlèvement et remorquage sur devis selon la distance. Nous vous confirmons l'heure de passage par téléphone ou WhatsApp.",
        subject: "Sujet de votre question",
        subjectPh: "Ex : Délai pour une peinture complète",
        questionMessage: "Votre question",
        questionMessagePh: "Posez votre question en quelques lignes...",
        contactRequired: "Le numéro WhatsApp est obligatoire ; l'e-mail est facultatif.",
        prefilled: "Vos informations ont été préremplies depuis votre espace client : choisissez simplement le service, la date et l'heure.",
        emailSimple: "Email (facultatif)",
        phoneSimple: "Numéro WhatsApp",
        submitQuestion: "Envoyer ma question",
        questionSuccess: "Question envoyée ! Nous vous répondons très vite.",
        pickupSuccess: "Demande d'enlèvement envoyée ! Nous vous confirmons le passage sous 24h.",
        name: "Nom complet",
        namePh: "Votre nom",
        phone: "Numéro WhatsApp",
        phonePh: "+225 ...",
        service: "Service souhaité",
        servicePh: "Choisissez un service",
        groupServices: "Services atelier",
        groupActivities: "Autres activités",
        vehicle: "Marque & modèle du véhicule",
        vehiclePh: "Ex : Mercedes GLE 450",
        date: "Date souhaitée",
        time: "Créneau horaire",
        timeHint: "Choisissez une date pour voir les créneaux disponibles (Lun – Sam, 8h – 18h).",
        timeClosed: "L'atelier est fermé le dimanche. Choisissez un autre jour.",
        timeClosedDay: "L'atelier est exceptionnellement fermé ce jour-là",
        email: "Email (facultatif : pour recevoir devis, rappels et facture)",
        emailPh: "vous@exemple.com",
        photos: "Photos des dégâts (jusqu'à 5)",
        photosHint: "Ajoutez des photos pour un chiffrage plus précis (JPG, PNG ou WebP).",
        photosMax: "Maximum 5 photos",
        photosUploading: "Envoi des photos...",
        timeNone: "Aucun créneau disponible ce jour-là.",
        timeTaken: "Réservé",
        timeConflict: "Ce créneau vient d'être réservé, choisissez-en un autre.",
        message: "Décrivez le problème ou votre besoin",
        messagePh: "Détails, symptômes, historique...",
        submit: "Envoyer ma demande",
        sending: "Envoi en cours...",
        success: "Demande envoyée ! Nous vous recontactons sous 24h.",
        error: "Une erreur est survenue. Réessayez ou contactez-nous sur WhatsApp.",
        whatsappAlso: "Envoyer aussi sur WhatsApp",
        whatsappHint: "Pour une réponse encore plus rapide, envoyez votre demande directement au directeur.",
        newRequest: "Nouvelle demande",
        waIntro: "Bonjour Groupe Auto Luxe, je viens d'envoyer une demande de devis :",
      },
      info: {
        title: "Coordonnées",
        address: "Adresse",
        addressValue: "Koumassi Remblais, derrière la station PETROCI, 01 BP 924 Abidjan 01",
        phone: "Téléphone / WhatsApp",
        email: "Email",
        website: "Site web",
        hours: "Horaires",
        hoursValue: "Lun – Sam : 8h00 – 18h00",
        whatsCta: "Discuter sur WhatsApp",
      },
    },
    cta: {
      title: "Votre véhicule mérite",
      titleAccent: "le meilleur atelier",
      sub: "Devis gratuit, diagnostic précis, résultat garanti.",
      button: "Demander un devis",
    },
    footer: {
      slogan: "La satisfaction client, notre credo",
      navTitle: "Navigation",
      servicesTitle: "Services",
      contactTitle: "Contact",
      hours: "Lun – Sam : 8h00 – 18h00",
      rights: "Tous droits réservés.",
      activitiesTitle: "Activités",
      admin: "Espace entreprise",
    },
    whatsapp: {
      label: "WhatsApp",
      message: "Bonjour Groupe Auto Luxe, je souhaite une demande de devis",
    },
    client: {
      kicker: "Espace client",
      title: "Mon espace client",
      subtitle: "Retrouvez l'historique de vos réparations, vos devis, vos factures et vos prochains rappels d'entretien.",
      phone: "Numéro WhatsApp utilisé lors de votre demande",
      code: "Un code de suivi (reçu par e-mail ou WhatsApp)",
      codeHint: "N'importe quel code de suivi GAL-XXXXXX d'une de vos réparations suffit. Vous avez aussi reçu un lien direct dans nos messages.",
      open: "Ouvrir mon espace",
      notFound: "Aucun dossier ne correspond à ces informations. Vérifiez le numéro et le code, ou contactez-nous.",
      back: "Réessayer",
      hello: "Bonjour",
      kpiRepairs: "Dossiers", kpiUpcoming: "Rendez-vous à venir", kpiUnpaid: "Reste à régler", kpiPaid: "Total réglé",
      nextAppointment: "Prochain rendez-vous", maintenance: "Rappel d'entretien", maintenanceDue: "Entretien conseillé depuis le", maintenanceOn: "Entretien conseillé le", delivered: "livré le", book: "Prendre rendez-vous →",
      loyalty: "Client fidèle", loyaltyText: "Merci pour votre fidélité : remise de", loyaltyCode: "code",
      history: "Historique de mes réparations", track: "Suivre", estimate: "Devis", invoice: "Facture", paid: "payée le", toPay: "à régler", photos: "photo(s) du véhicule réparé",
      footer: "Une question sur votre dossier ? Appelez-nous au",
      rebook: "Reprendre rendez-vous", rebookFor: "Rendez-vous pour ce véhicule", pickup: "Demander un enlèvement",
    },
    payments: { title: "Moyens de paiement", holder: "Bénéficiaire" },
    ai: {
      help: "M'aider à rédiger (IA)",
      hint: "Tapez quelques mots (ex : « bruit frein avant, Toyota, depuis 2 jours ») et l'assistant rédige un message clair que vous pourrez modifier.",
      placeholder: {
        quote: "Ex : bruit frein avant, voyant moteur, Toyota Corolla…",
        pickup: "Ex : voiture ne démarre plus, garée à Cocody…",
        question: "Ex : délai pour une peinture complète ?",
        review: "Ex : peinture impeccable, délai respecté, accueil…",
        application: "Ex : mécanicien 3 ans d'expérience, disponible tout de suite…",
      },
      generate: "Rédiger",
      writing: "Rédaction…",
      done: "Message rédigé : relisez et modifiez si besoin",
      error: "L'assistant est indisponible, réessayez",
      tooShort: "Écrivez au moins quelques mots",
      voiceHint: "Vous pouvez aussi dicter votre message : appuyez sur le micro, parlez, puis arrêtez.",
      voice: { start: "Dicter", stop: "Arrêter", transcribing: "Transcription…", error: "Impossible de transcrire, réessayez", denied: "Micro non autorisé : autorisez l'accès au micro dans votre navigateur", tooShort: "Enregistrement trop court" },
      chat: {
        button: "Assistant",
        title: "Assistant Groupe Auto Luxe",
        welcome: "Bonjour, je suis l'assistant virtuel de Groupe Auto Luxe. Posez votre question sur nos services, nos horaires ou nos garages.",
        suggestions: ["Quels sont vos horaires ?", "Où êtes-vous situés ?", "Réparez-vous les Mercedes ?", "Comment suivre ma réparation ?"],
        placeholder: "Votre question…",
        send: "Envoyer",
        typing: "L'assistant rédige…",
        error: "Désolé, je n'arrive pas à répondre pour le moment. Contactez-nous par WhatsApp.",
        footer: "Besoin d'une personne ?",
        contact: "Page Contact",
      },
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      gallery: "Gallery",
      contact: "Contact",
      track: "Tracking",
      login: "Login",
      news: "News",
      history: "Our story",
      cta: "Instant Quote",
    },
    news: {
      overline: "News",
      title: "Latest news from",
      accent: "the workshop",
      sub: "Promotions, new services and workshop life: follow the latest information from Groupe Auto Luxe.",
      all: "All news",
      read: "Read more",
      back: "Back to news",
      empty: "No news yet. Check back soon!",
      filterAll: "All",
      link: "Learn more",
      tabs: { ours: "Our workshop", ci: "Côte d'Ivoire", world: "World", auto: "Automotive" },
      external: { overline: "Headlines", title: "Côte d'Ivoire, world &", accent: "automotive", ci: "In Côte d'Ivoire", world: "Around the world", auto: "Automotive news", readOn: "Read article", empty: "Feed unavailable right now.", updated: "Refreshed automatically every 30 minutes from external sources", more: "See more" },
      categories: { promo: "Promotion", service: "New service", atelier: "Workshop life", info: "Information" },
      share: { label: "Share", whatsapp: "WhatsApp", facebook: "Facebook", copy: "Copy link", copied: "Link copied!" },
    },
    history: {
      overline: "Our story",
      title: "A company that keeps",
      accent: "moving forward",
      intro: "Groupe Auto Luxe was born in Koumassi-Remblais from a passion for mechanics and one simple conviction: customer satisfaction comes first. Year after year, the neighbourhood workshop became a multi-brand repairer approved by insurance companies and, in 2024, a formally incorporated company with two modern garages in Abidjan.",
      missionTitle: "Beyond repairs",
      mission: "Our ambition goes beyond car repair. We want to contribute to the development of Côte d'Ivoire by training and employing young people in automotive trades, passing on demanding know-how and offering lasting prospects to the next generation. Every vehicle repaired is also a skill passed on.",
      milestones: [
        { year: "Origins", title: "The beginnings in Koumassi", text: "Opening of the workshop in Koumassi-Remblais: general mechanics, bodywork and paint for a loyal local clientele." },
        { year: "2023", title: "Insurance approvals", text: "First approvals from insurance companies and expert firms for the repair of damaged vehicles and technical assistance. Every file entrusted to us is completed on time and to the expected quality." },
        { year: "2024", title: "Incorporation as an LLC", text: "Incorporation of Groupe Auto Luxe SARL, with a share capital of 1,000,000 FCFA and a 99-year term, registered with the Abidjan Trade Register and declared to the tax and social authorities." },
        { year: "2024", title: "Two modern garages", text: "Opening of a second site in Port-Bouët Gonzagueville alongside the Koumassi-Remblais workshop. Our technicians, trained in new technologies, work on all brands in line with manufacturers' specifications." },
        { year: "Since 2025", title: "Looking ahead", text: "Expansion into parts sales, rental and import-export, together with a concrete commitment to training and employing young Ivorians." },
      ],
      facts: [
        { label: "Legal form", value: "SARL (LLC)" },
        { label: "Share capital", value: "1,000,000 FCFA" },
        { label: "Term", value: "99 years" },
        { label: "Sites", value: "2 garages in Abidjan" },
        { label: "Insurance-approved", value: "since 2023" },
        { label: "Brands served", value: "20+" },
      ],
      charterTitle: "Our quality charter",
      charter: ["Welcome · Availability · Responsiveness", "Clarity · Rigour · Transparency", "Personalisation · Listening · Follow-up", "Skills · Experience · Know-how", "Confidentiality · Respect · Discretion", "Quality · Assessment · Improvement"],
    },
    estimate: {
      overline: "Your estimate",
      title: "Estimate No.",
      sub: "Review the details below, then accept or decline in one click.",
      pdf: "View PDF",
      accept: "I accept the estimate",
      refuse: "I decline",
      comment: "A comment for the workshop (optional)",
      accepted: "Thank you! Your estimate is accepted. The workshop will contact you shortly to schedule the work.",
      refused: "Your decision has been sent to the workshop. Feel free to call us to discuss.",
      alreadyOn: "Decision recorded on",
      notFound: "This estimate cannot be found or the link has expired.",
      total: "Total",
      validity: "Valid for",
      days: "days",
      hello: "Hello",
    },
    track: {
      overline: "Repair tracking",
      title: "Where is",
      titleAccent: "my vehicle?",
      sub: "Enter the tracking code received with your request (e.g. GAL-3F9A2C) to follow your vehicle's progress.",
      placeholder: "GAL-XXXXXX",
      button: "Track",
      notFound: "Code not found. Check the code received with your request.",
      pending: "Your request is registered. Tracking will start once your vehicle arrives at the workshop.",
      steps: { recu: "Vehicle received", en_cours: "Repair in progress", pret: "Vehicle ready", livre: "Vehicle delivered" },
      stepsDesc: {
        recu: "Your vehicle is at the workshop, diagnostics are underway.",
        en_cours: "Our technicians are working on your vehicle.",
        pret: "Your vehicle is waiting for you! Contact us to pick it up.",
        livre: "Thank you for your trust. See you soon at Groupe Auto Luxe.",
      },
      hello: "Hello",
      vehicle: "Vehicle",
      service: "Service",
      rdv: "Appointment",
      history: "History",
      codeLabel: "Your tracking code",
      codeHint: "Keep it: it lets you follow your vehicle's progress on the Tracking page.",
    },
    hero: {
      badge: "Car repair workshop approved by insurance companies in Abidjan",
      line1: "Automotive",
      line2: "excellence",
      line3: "in Abidjan",
      sub: "Mechanics, bodywork, paint, electrical, upholstery and air conditioning: your vehicle in the hands of master craftsmen.",
      ctaQuote: "Request a quote",
      ctaWhats: "Direct WhatsApp",
      chips: ["100% Diagnostics", "High-Definition Paint", "Certified Parts"],
      scroll: "Scroll",
    },
    marquee: ["GROUPE AUTO LUXE", "MECHANICS", "BODYWORK", "PAINT", "ELECTRICAL", "UPHOLSTERY", "AIR CONDITIONING", "ABIDJAN 01"],
    credo: {
      overline: "Our Creed",
      text: "Client satisfaction is our creed. Every vehicle that enters our atelier receives the same level of demand: that of a work of art.",
    },
    stats: {
      items: [
        { v: "6", l: "Expert disciplines" },
        { v: "20+", l: "Brands serviced" },
        { v: "10+", l: "Insurance partners" },
        { v: "24h", l: "Response time" },
      ],
    },
    servicesPreview: {
      overline: "Our Expertise",
      title: "Six disciplines, one obsession",
      cta: "Discover all our services",
    },
    activities: {
      overline: "Our Activities",
      title: "Much more than",
      titleAccent: "a workshop",
      sub: "Groupe Auto Luxe covers the entire automotive value chain: from repair to sales, from rental to import-export.",
      items: [
        { title: "General mechanics", desc: "Maintenance, repair and diagnostics for all brands by qualified technicians." },
        { title: "Auto parts sales", desc: "Genuine and compatible spare parts, in stock or on fast order." },
        { title: "Vehicle purchase, sales & rental", desc: "Inspected used vehicles, purchase assistance and short or long-term rental." },
        { title: "Miscellaneous services", desc: "Technical assistance, appraisal, vehicle delivery and tailor-made services for individuals and businesses." },
        { title: "General trade", desc: "Trading and distribution of products and equipment for the automotive sector." },
        { title: "Import – Export", desc: "Vehicle and parts import, export and international logistics." },
      ],
    },
    services: {
      overline: "Our Expertise",
      title: "Six disciplines,",
      titleAccent: "one obsession",
      sub: "From precision mechanics to exceptional upholstery, each discipline is a chapter of our artisan manifesto.",
      specsLabel: "Key services",
      quoteCta: "Request a quote",
      items: [
        {
          num: "01",
          title: "Mechanics",
          tagline: "The heart of the machine",
          desc: "Full electronic diagnostics, engine servicing, braking, suspension and transmission. Our technicians restore your vehicle to its original performance, or better.",
          specs: ["Multi-brand electronic diagnostics", "Engine service and rebuild", "Braking, suspension, transmission", "Scheduled preventive maintenance"],
        },
        {
          num: "02",
          title: "Bodywork",
          tagline: "The art of straightening",
          desc: "Dent removal, bench straightening, body panel replacement. We restore the exact geometry of your vehicle after any impact.",
          specs: ["Precision bench straightening", "Paintless dent removal", "Original panel replacement", "Structural repair after accidents"],
        },
        {
          num: "03",
          title: "Paint",
          tagline: "High definition",
          desc: "Professional paint booth, factory-matched colour, high-definition finish. Your bodywork regains its showroom shine.",
          specs: ["Professional paint booth", "Spectrophotometer colour matching", "High-definition finish", "Ceramic coating on request"],
        },
        {
          num: "04",
          title: "Electrical",
          tagline: "The nervous system",
          desc: "Wiring harnesses, alternators, starters, on-board electronics and multimedia systems. We master the most complex electrical networks.",
          specs: ["Wiring harness diagnostics", "Alternators and starters", "On-board electronics and ECUs", "Audio and multimedia systems"],
        },
        {
          num: "05",
          title: "Upholstery",
          tagline: "An exceptional interior",
          desc: "Leather trim, seat restoration, headliners and bespoke fittings. We transform your cabin into a luxury showcase.",
          specs: ["Leather and alcantara trim", "Complete seat restoration", "Headliners and door panels", "Bespoke fittings"],
        },
        {
          num: "06",
          title: "Air Conditioning",
          tagline: "Absolute comfort",
          desc: "Gas recharge, compressor replacement, leak detection and circuit disinfection. Pure, cool air, all year round.",
          specs: ["Circuit recharge and diagnostics", "Compressor replacement", "UV leak detection", "Anti-bacterial disinfection"],
        },
      ],
    },
    gallery: {
      overline: "Our Atelier",
      title: "The work speaks",
      titleAccent: "for itself",
      sub: "Real photos of our workshop, our teams and our work. Nothing invented, simply the reality of Groupe Auto Luxe.",
      filters: { all: "All", entreprise: "The Company", mecanique: "Mechanics & Diagnostics", tolerie: "Bodywork & Paint", tapisserie: "Upholstery & Interior", formation: "Training & Youth" },
      empty: "No photos in this category yet. Managers publish photos from the company area.",
      count: "photos",
      items: [
        { cat: "mecanique", caption: "V8 engine rebuild" },
        { cat: "mecanique", caption: "Engine bay diagnostics" },
        { cat: "mecanique", caption: "Lift intervention" },
        { cat: "tolerie", caption: "Studio paint finish" },
        { cat: "tolerie", caption: "SUV in restoration" },
        { cat: "tolerie", caption: "Premium bodyshop" },
        { cat: "tapisserie", caption: "Bespoke leather cabin" },
        { cat: "tapisserie", caption: "Starlit upholstery" },
      ],
    },
    leadership: {
      overline: "Leadership",
      title: "Expert hands,",
      titleAccent: "a clear vision",
      members: [
        {
          name: "Kola Cissé Barry",
          role: "Chairman of the Board (PCA)",
          phone: "+225 07 88 16 24 02",
          bio: "At the head of the Board of Directors, he carries the vision of Groupe Auto Luxe: an exemplary Ivorian company focused on excellence, youth training and the development of the country.",
        },
        {
          name: "Ousmane B. Traore",
          role: "Managing Director",
          phone: "+225 05 05 54 13 13",
          bio: "A visionary and builder, he has made Groupe Auto Luxe the benchmark for premium automotive care in Abidjan, with one absolute demand: every client's satisfaction.",
        },
        {
          name: "Abdoul-Alim Diallo",
          role: "Advisor to the Managing Director, Head of Economic Intelligence",
          phone: "+33 7 80 79 68 27",
          bio: "He supports management in its strategic decisions: automotive market watch, analysis of competition and opportunities, partnerships and business development.",
        },
        {
          name: "Zakaria Diallo",
          role: "Technical Manager",
          phone: "+225 07 48 83 38 40",
          bio: "Master technician and guardian of quality, he supervises every intervention with the rigour of an engineer and the passion of a craftsman.",
        },
      ],
    },
    partners: {
      overline: "Accreditations & Partners",
      title: "Approved by the",
      titleAccent: "leading insurers",
      sub: "Groupe Auto Luxe is an approved atelier for the repair and technical assistance of insured vehicles. Your claim is handled directly, with no upfront payment depending on your policy.",
      groupAssurance: "Insurance companies",
      groupExpertise: "Appraisal firms & organisations",
      legal: "Trade register: CI-ABJ-03-2024-B12-08712 · Unique ID: CI-2024-0019709 J",
      brandsLabel: "All brands serviced",
      brands: ["TOYOTA", "MERCEDES-BENZ", "BMW", "VOLKSWAGEN", "AUDI", "PEUGEOT", "RENAULT", "NISSAN", "HYUNDAI", "KIA", "HONDA", "FORD", "VOLVO", "SUZUKI", "MAZDA", "MITSUBISHI", "CITROËN", "OPEL", "FIAT", "DACIA"],
    },
    testimonials: {
      overline: "Customer Reviews",
      title: "They trusted us with",
      titleAccent: "their vehicle",
      sub: "Genuine reviews, published after validation by our team.",
      empty: "Be the first to share your experience with Groupe Auto Luxe.",
      leave: "Leave a review",
      form: {
        name: "Your name",
        vehicle: "Your vehicle (optional)",
        rating: "Your rating",
        comment: "Your review",
        commentPh: "Tell us about your experience...",
        submit: "Send my review",
        success: "Thank you! Your review will be published after validation.",
        error: "Could not send the review. Please try again.",
      },
    },
    beforeAfter: {
      overline: "Before / After",
      title: "Slide to see",
      titleAccent: "the transformation",
      sub: "Drag the slider to compare the vehicle before and after our work.",
      before: "Before",
      after: "After",
      empty: "Our first before / after comparisons are coming soon.",
      cta: "See all transformations",
    },
    faq: {
      overline: "FAQ",
      title: "Everything to know before",
      titleAccent: "trusting us with your vehicle",
      items: [
        {
          q: "Are you approved by insurance companies?",
          a: "Yes. Groupe Auto Luxe is approved for vehicle repair and technical assistance with the country's leading insurers (GNA-CI, NSIA, Sanlam Allianz, SUNU, Activa, AFG...). We handle your claim file directly with your insurer.",
        },
        {
          q: "Which vehicle brands do you accept?",
          a: "All brands: Toyota, Mercedes-Benz, BMW, Peugeot, Renault, Hyundai, Kia, Nissan, Volkswagen, Audi and many more. Our diagnostic equipment is multi-brand.",
        },
        {
          q: "How quickly do I get a quote?",
          a: "We answer every request within 24 business hours. For an even faster estimate, send us photos of the damage directly on WhatsApp at +225 05 05 54 13 13.",
        },
        {
          q: "Where exactly is the atelier located?",
          a: "We have two sites in Abidjan: Koumassi Remblais, right behind the PETROCI station (01 BP 924 Abidjan 01), and Port-Bouët Gonzagueville. Open Monday to Saturday, 8:00 AM to 6:00 PM.",
        },
        {
          q: "Do you provide pre-repair assessment reports?",
          a: "Yes. We carry out a full diagnostic with photo reports before, during and after the work: a transparent file accepted by insurance assessors.",
        },
      ],
    },
    recruit: {
      nav: "Join us",
      overline: "Join us",
      title: "Let's build the future",
      accent: "together",
      sub: "Groupe Auto Luxe trains and hires young people passionate about cars. Job, internship or training: your journey starts here, in Abidjan.",
      pillars: {
        job: { title: "Job", desc: "Join a team of qualified technicians in a workshop approved by insurance companies." },
        internship: { title: "Internship", desc: "Students and young graduates: discover the trade in the field, guided by experienced professionals." },
        training: { title: "Training", desc: "Learn mechanics, bodywork, paint or automotive electrics alongside our experts." },
      },
      offersTitle: "Current openings",
      noOffers: "No openings published right now. Send us a spontaneous application, we review every profile.",
      apply: "Apply",
      formTitle: "Submit my application",
      formSub: "A few details are enough. We get back to you quickly by phone or WhatsApp.",
      form: {
        type: "I am looking for",
        offer: "Related opening",
        spontaneous: "Spontaneous application",
        domain: "Preferred field",
        domainPh: "Choose a field",
        domains: ["Mechanics", "Bodywork", "Paint", "Automotive electrics", "Air conditioning", "Upholstery", "Reception and administration", "Other"],
        message: "Introduce yourself in a few lines",
        messagePh: "Your background, motivations, availability...",
        cv: "Your CV (PDF, Word or image, 5 MB max)",
        cvChoose: "Attach my CV",
        cvOptional: "Optional but recommended",
        submit: "Send my application",
        sending: "Sending...",
        success: "Application sent! Thank you for your trust, we will get back to you very soon.",
        again: "Send another application",
        error: "Something went wrong. Try again or contact us on WhatsApp.",
      },
      types: { job: "A job", internship: "An internship", training: "A training" },
      galleryOverline: "In pictures",
      galleryTitle: "Workshop life,",
      galleryAccent: "youth side",
      gallerySub: "Apprentices and interns at work, guided by our technicians.",
      galleryAll: "See the full gallery",
      testimonialsOverline: "They started here",
      testimonialsTitle: "Young people who",
      testimonialsAccent: "speak up",
      testimonials: [
        { name: "Yao Kouassi", role: "Apprentice mechanic, 21", text: "I arrived with no experience. In six months I learned diagnostics, oil changes, brakes. The technicians take time to explain, you are never left on your own." },
        { name: "Aïcha Diabaté", role: "Bodywork and paint intern", text: "My internship let me work on real bodywork, on customer and insurance vehicles. Today I can prepare a body from straightening to varnish." },
        { name: "Moussa Traoré", role: "Automotive electrician, hired after his training", text: "Trained here, hired here. Groupe Auto Luxe trusted me and gave me a trade. That is the chance I want to pass on to younger people." },
      ],
    },
    vehicles: {
      nav: "Vehicles",
      overline: "Sales, purchase & rental",
      title: "Find your",
      accent: "next vehicle",
      sub: "Used vehicles inspected by our workshop, for sale or for rent in Abidjan. Want to sell yours? We buy it.",
      tabs: { all: "All", sale: "For sale", rent: "For rent", part_sale: "Parts for sale", part_wanted: "Parts wanted" },
      kind: { sale: "For sale", rent: "For rent", part_sale: "Part for sale", part_wanted: "Part wanted" },
      heads: {
        rent: { overline: "Vehicle rental", title: "Rent a", accent: "reliable, serviced vehicle", sub: "Sedans, SUVs and vans checked by our workshop, by the day, week or month. Driver available on request." },
        part_sale: { overline: "Spare parts", title: "Genuine and", accent: "inspected used parts", sub: "Mechanical, body, electrical parts and accessories checked by our technicians, fitting available at the workshop." },
        part_wanted: { overline: "We buy your parts", title: "Do you have", accent: "the part we need?", sub: "We are looking for these parts for ongoing repairs. If you own one, click “I have this part” and we will call you back to agree on a price." },
      },
      request: {
        rent: { overline: "Rental request", title: "Book", accent: "your vehicle", sub: "Tell us the vehicle type, dates and duration: we confirm availability and price quickly.", subject: "Vehicle rental request", needLabel: "Vehicle wanted and dates", needPh: "E.g. 7-seat SUV from 12 to 15 March, with driver", extraLabel: "Budget or details", extraPh: "E.g. 50,000 FCFA / day max", submit: "Send my rental request", success: "Request received! We will confirm availability very soon.", again: "New request", waIntro: "Hello, I would like to rent a vehicle:" },
        part_sale: { overline: "Looking for a part?", title: "Request", accent: "the part you need", sub: "Can't find your part in the list? Describe it: we search our stock and our suppliers.", subject: "Spare part request", needLabel: "Part wanted and vehicle", needPh: "E.g. Alternator for Toyota Hilux 2018 diesel", extraLabel: "Reference, condition, budget", extraPh: "E.g. new or used, 150,000 FCFA max", submit: "Request this part", success: "Request received! We will reply quickly with a price and lead time.", again: "Request another part", waIntro: "Hello, I am looking for a part:" },
        part_wanted: { overline: "Have a part to offer?", title: "Offer", accent: "your part", sub: "Even if it is not in our list, describe the part you want to sell: we make an offer after inspection.", subject: "Spare part offer", needLabel: "Part offered and compatible vehicle", needPh: "E.g. Right front headlight Prado 2017, used, good condition", extraLabel: "Asking price", extraPh: "E.g. 80,000 FCFA", submit: "Offer my part", success: "Thank you! We will call you back to agree on a price.", again: "Offer another part", waIntro: "Hello, I would like to offer you a part:" },
      },
      parts: {
        category: { moteur: "Engine", carrosserie: "Body", freinage: "Brakes", electrique: "Electrical", pneus: "Tyres & rims", accessoires: "Accessories", autre: "Other" },
        condition: { neuf: "New", occasion: "Used", reconditionne: "Refurbished" },
        compatible: "Compatible vehicles", quantity: "Quantity", categoryLabel: "Category", conditionLabel: "Condition",
        wanted: "We are looking for this part", wantedSub: "Do you own this part or can you supply it? Leave your details and we will call you back to agree on a price.",
        haveIt: "I have this part", haveItSent: "Thank you! We will call you back very soon about this part.",
        empty: "No part in this category right now. Contact us: we can order it for you.",
        emptyWanted: "No part wanted right now. Have a part to offer us? Use the form below.",
        homeOverline: "Spare parts", homeTitle: "Parts", homeAccent: "for sale", homeAccentWanted: "for sale and wanted",
        homeSub: "Genuine and used parts checked by our workshop. Do you have a part we are looking for? Let us know.",
        all: "See all parts",
        search: "Search a part", searchPh: "Search: name, compatible vehicle, reference…", allCategories: "All", noResult: "No part matches your search. Try another word or category.",
      },
      status: { available: "Available", reserved: "Reserved" },
      onRequest: "Price on request",
      perDay: "/ day",
      photos: "photos",
      color: "Colour",
      fuel: { essence: "Petrol", diesel: "Diesel", hybride: "Hybrid", electrique: "Electric", autre: "Other" },
      gearbox: { manuelle: "Manual", automatique: "Automatic" },
      details: "View",
      interestTitle: "Interested in this vehicle?",
      interestSub: "Leave your details and an advisor will call you back shortly. Or message us directly on WhatsApp.",
      message: "Your message (optional)",
      messagePh: "E.g. I would like a test drive on Saturday morning.",
      send: "Send my request",
      sending: "Sending...",
      whatsapp: "Chat on WhatsApp",
      sent: "Request sent! We will call you back very soon.",
      empty: "No vehicle available right now. Contact us: we can source the vehicle you need.",
      homeTitle: "Vehicles",
      homeAccent: "for sale and for rent",
      all: "See all vehicles",
      openPage: "Open full listing",
      back: "All vehicles",
      notFound: "This vehicle is no longer available.",
      sell: {
        overline: "We buy",
        title: "Sell us",
        accent: "your vehicle",
        sub: "Describe your vehicle, add a few photos and tell us your asking price. We make you an offer after an inspection at the workshop.",
        brand: "Brand", model: "Model", year: "Year", mileage: "Mileage (km)", fuel: "Fuel", gearbox: "Gearbox",
        price: "Asking price (FCFA, optional)", photos: "Vehicle photos", message: "Description, condition, options",
        messagePh: "E.g. One owner, full service history, new tyres.",
        submit: "Offer my vehicle",
        success: "Thank you! We received your offer and will contact you shortly.",
        again: "Offer another vehicle",
        error: "Could not send, please try again.",
      },
    },
    seo: {
      home: { title: "Insurance-approved car repair garage in Abidjan: mechanics, bodywork, paint", description: "Groupe Auto Luxe, car repair garage in Abidjan (Koumassi, Port-Bouët) approved by insurance companies: mechanics, bodywork, paint, electrics, air conditioning, upholstery. Free quote, online repair tracking." },
      services: { title: "Our services: mechanics, bodywork, paint, auto electrics in Abidjan", description: "All the services of our Abidjan garage: general mechanics, bodywork and paint, automotive electrics, air conditioning, upholstery, spare parts, vehicle rental and import-export." },
      gallery: { title: "Gallery: our work and our workshop", description: "Photos of our repairs, our Koumassi and Port-Bouët workshops and our teams at work. Bodywork and paint before / after." },
      contact: { title: "Free quote, appointment or vehicle pick-up in Abidjan", description: "Request a free quote, book an appointment, have your vehicle collected at home or ask a question. Quick answer by phone or WhatsApp." },
      history: { title: "Our story: an Ivorian garage committed to youth", description: "From neighbourhood workshop to insurance-approved company: the story of Groupe Auto Luxe, its values, quality charter and commitment to training and employing young people in Côte d'Ivoire." },
      news: { title: "News: workshop, Côte d'Ivoire, world and automotive", description: "Promotions, new services and workshop life at Groupe Auto Luxe, plus news from Côte d'Ivoire, the world and the automotive industry." },
      recruit: { title: "Join us: jobs, internships and automotive training in Abidjan", description: "Groupe Auto Luxe hires and trains young people passionate about cars in Abidjan: job openings, internships and training in mechanics, bodywork, paint and auto electrics." },
      vehicles: { title: "Used vehicles for sale and for rent in Abidjan", description: "Used cars inspected by the Groupe Auto Luxe workshop, for sale or for rent in Abidjan. We also buy your vehicle: offer it online with photos." },
      track: { title: "Track my vehicle repair", description: "Follow the progress of your vehicle repair in real time with your tracking code." },
    },
    maps: { overline: "Our garages", title: "Where to", accent: "find us", sub: "Two sites in Abidjan, open Monday to Saturday.", directions: "Get directions", hours: "Hours", open: "Open in Google Maps" },
    track_docs: { invoice: "Download my invoice (PDF)", estimate: "Download my estimate (PDF)", paid: "Invoice paid, thank you", scan: "Scan to pay with" },
    vcard: {
      overline: "Business cards",
      title: "Keep us",
      accent: "in your contacts",
      sub: "Scan the QR code with your phone or download the contact file (vCard) to save our managers directly to your address book.",
      scan: "Scan to add the contact",
      download: "Download vCard",
    },
    contact: {
      overline: "Contact & Quote",
      title: "Let's talk about",
      titleAccent: "your vehicle",
      sub: "Describe your need, we will reply within 24h with a detailed, no-commitment quote.",
      types: {
        devis: { title: "Request a quote", desc: "Describe the work, add photos: we send a price within 24h, no commitment." },
        rdv: { title: "Appointment at the workshop", desc: "You bring your vehicle on the date and time of your choice." },
        pickup: { title: "Have my vehicle collected", desc: "We come and pick up your vehicle at the address you provide." },
        question: { title: "Ask a question", desc: "Just a question? Write to us, we answer quickly." },
      },
      form: {
        devisMessage: "Describe the work to be quoted",
        devisMessagePh: "E.g.: scratch on the front left door, braking noise, bumper replacement...",
        devisSubmit: "Get my quote",
        devisSuccess: "Quote request sent! You will receive our estimate within 24h.",
        devisWaIntro: "Hello Groupe Auto Luxe, I would like a quote:",
        rdvMessage: "Reason for the appointment",
        rdvMessagePh: "E.g.: oil change + brake check, engine light diagnosis...",
        rdvSubmit: "Book my appointment",
        rdvSuccess: "Appointment requested! We confirm the slot within 24h.",
        rdvWaIntro: "Hello Groupe Auto Luxe, I just requested a workshop appointment:",
        pickupMessage: "Vehicle condition and work needed",
        pickupMessagePh: "E.g.: won't start, runs but makes a noise, minor accident...",
        pickupSubmit: "Request pick-up",
        pickupWaIntro: "Hello Groupe Auto Luxe, I just requested a vehicle pick-up:",
        pickupAddress: "Vehicle pick-up address",
        pickupAddressPh: "Neighbourhood, street, landmark (e.g. Cocody Riviera 3, near the pharmacy ...)",
        pickupDate: "Preferred pick-up date",
        period: "Preferred period",
        periodPh: "Choose a period",
        periodMorning: "Morning (8am to 12pm)",
        periodAfternoon: "Afternoon (12pm to 6pm)",
        pickupNote: "Collection and towing quoted according to distance. We confirm the pick-up time by phone or WhatsApp.",
        subject: "Subject of your question",
        subjectPh: "E.g. Lead time for a full repaint",
        questionMessage: "Your question",
        questionMessagePh: "Ask your question in a few lines...",
        contactRequired: "WhatsApp number is required; email is optional.",
        prefilled: "Your details were pre-filled from your customer area: simply choose the service, date and time.",
        emailSimple: "Email (optional)",
        phoneSimple: "WhatsApp number",
        submitQuestion: "Send my question",
        questionSuccess: "Question sent! We will get back to you very soon.",
        pickupSuccess: "Pick-up request sent! We confirm the visit within 24h.",
        name: "Full name",
        namePh: "Your name",
        phone: "WhatsApp number",
        phonePh: "+225 ...",
        service: "Desired service",
        servicePh: "Choose a service",
        groupServices: "Workshop services",
        groupActivities: "Other activities",
        vehicle: "Vehicle make & model",
        vehiclePh: "E.g.: Mercedes GLE 450",
        date: "Preferred date",
        time: "Time slot",
        timeHint: "Pick a date to see available slots (Mon – Sat, 8 AM – 6 PM).",
        timeClosed: "The workshop is closed on Sundays. Please pick another day.",
        timeClosedDay: "The workshop is exceptionally closed on this day",
        email: "Email (optional: to receive quote, reminders and invoice)",
        emailPh: "you@example.com",
        photos: "Damage photos (up to 5)",
        photosHint: "Add photos for a more accurate estimate (JPG, PNG or WebP).",
        photosMax: "Maximum 5 photos",
        photosUploading: "Uploading photos...",
        timeNone: "No slot available on this day.",
        timeTaken: "Booked",
        timeConflict: "This slot was just booked, please choose another one.",
        message: "Describe the issue or your need",
        messagePh: "Details, symptoms, history...",
        submit: "Send my request",
        sending: "Sending...",
        success: "Request sent! We will get back to you within 24h.",
        error: "Something went wrong. Try again or reach us on WhatsApp.",
        whatsappAlso: "Also send on WhatsApp",
        whatsappHint: "For an even faster reply, send your request directly to the director.",
        newRequest: "New request",
        waIntro: "Hello Groupe Auto Luxe, I just sent a quote request:",
      },
      info: {
        title: "Contact details",
        address: "Address",
        addressValue: "Koumassi Remblais, behind the PETROCI station, 01 BP 924 Abidjan 01",
        phone: "Phone / WhatsApp",
        email: "Email",
        website: "Website",
        hours: "Opening hours",
        hoursValue: "Mon – Sat: 8:00 AM – 6:00 PM",
        whatsCta: "Chat on WhatsApp",
      },
    },
    cta: {
      title: "Your vehicle deserves",
      titleAccent: "the finest atelier",
      sub: "Free quote, precise diagnostics, guaranteed results.",
      button: "Request a quote",
    },
    footer: {
      slogan: "Client satisfaction, our creed",
      navTitle: "Navigation",
      servicesTitle: "Services",
      contactTitle: "Contact",
      hours: "Mon – Sat: 8:00 AM – 6:00 PM",
      rights: "All rights reserved.",
      activitiesTitle: "Activities",
      admin: "Company area",
    },
    whatsapp: {
      label: "WhatsApp",
      message: "Hello Groupe Auto Luxe, I would like to request a quote",
    },
    client: {
      kicker: "Customer area",
      title: "My customer area",
      subtitle: "Find the history of your repairs, your estimates, invoices and upcoming maintenance reminders.",
      phone: "WhatsApp number used for your request",
      code: "A tracking code (received by email or WhatsApp)",
      codeHint: "Any GAL-XXXXXX tracking code from one of your repairs is enough. You also received a direct link in our messages.",
      open: "Open my area",
      notFound: "No file matches this information. Check the number and code, or contact us.",
      back: "Try again",
      hello: "Hello",
      kpiRepairs: "Files", kpiUpcoming: "Upcoming appointments", kpiUnpaid: "Outstanding", kpiPaid: "Total paid",
      nextAppointment: "Next appointment", maintenance: "Maintenance reminder", maintenanceDue: "Service recommended since", maintenanceOn: "Service recommended on", delivered: "delivered on", book: "Book an appointment →",
      loyalty: "Loyal customer", loyaltyText: "Thank you for your loyalty: discount of", loyaltyCode: "code",
      history: "My repair history", track: "Track", estimate: "Estimate", invoice: "Invoice", paid: "paid on", toPay: "to pay", photos: "photo(s) of the repaired vehicle",
      footer: "A question about your file? Call us on",
      rebook: "Book again", rebookFor: "Book for this vehicle", pickup: "Request a pickup",
    },
    payments: { title: "Payment methods", holder: "Beneficiary" },
    ai: {
      help: "Help me write (AI)",
      hint: "Type a few words (e.g. “front brake noise, Toyota, since 2 days”) and the assistant drafts a clear message you can edit.",
      placeholder: {
        quote: "E.g. front brake noise, engine light, Toyota Corolla…",
        pickup: "E.g. car won't start, parked in Cocody…",
        question: "E.g. how long for a full paint job?",
        review: "E.g. flawless paint, on time, friendly staff…",
        application: "E.g. mechanic, 3 years experience, available now…",
      },
      generate: "Write",
      writing: "Writing…",
      done: "Message drafted: review and edit if needed",
      error: "The assistant is unavailable, please try again",
      tooShort: "Type at least a few words",
      voiceHint: "You can also dictate your message: press the mic, speak, then stop.",
      voice: { start: "Dictate", stop: "Stop", transcribing: "Transcribing…", error: "Could not transcribe, please try again", denied: "Microphone not allowed: please allow microphone access in your browser", tooShort: "Recording too short" },
      chat: {
        button: "Assistant",
        title: "Groupe Auto Luxe Assistant",
        welcome: "Hello, I am the virtual assistant of Groupe Auto Luxe. Ask me about our services, opening hours or workshops.",
        suggestions: ["What are your opening hours?", "Where are you located?", "Do you repair Mercedes?", "How do I track my repair?"],
        placeholder: "Your question…",
        send: "Send",
        typing: "The assistant is typing…",
        error: "Sorry, I cannot answer right now. Please contact us on WhatsApp.",
        footer: "Need a human?",
        contact: "Contact page",
      },
    },
  },
};
